<sbb-dialog-title i18n="@@SESSION_ANALYSE_TITLE" class="cd-text">Session Analyse in Cargo Digital</sbb-dialog-title>
<sbb-dialog-close-button></sbb-dialog-close-button>
<form [formGroup]="sessionForm" (ngSubmit)="onSubmit()">
  <sbb-dialog-content>
    <p i18n="@@SESSION_ANALYSE_TEXT" class="m-no-t">
      Um Cargo Digital stetig zu verbessern und Fehler schneller zu erkennen, analysieren wir das Nutzungsverhalten auf unserer Plattform. Mit Hilfe
      eines spezialisierten Analysetools werden die Aktivitäten aufgezeichnet. So können wir auch bei Supportanfragen gezielter und schneller helfen.
      Dabei werden personenbezogene Daten selbstverständlich vertraulich behandelt.
    </p>

    <div class="formAction">
      <sbb-checkbox [formControl]="sessionForm.controls.enabled">Ja, ich möchte dazu beitragen, Cargo Digital besser zu machen.</sbb-checkbox>
    </div>
    <sbb-link href="/settings" i18n="@@SESSION_ANALYSE_SETTING_LINK"> Session Analyse</sbb-link>
    <br />
    <sbb-link href="mailto:cargodigital@sbbcargo.com" i18n="@@SESSION_ANALYSE_FEEDBACK_LINK">
      Gerne nehmen wir auch jederzeit Ihr Feedback auf.</sbb-link
    >
  </sbb-dialog-content>

  <sbb-dialog-actions>
    <sbb-button cdkFocusInitial type="submit">
      <ng-container i18n="@@SESSION_ANALYSE_ACCEPT"> Speichern </ng-container>
    </sbb-button>

    <sbb-secondary-button type="button" (click)="onAbort()">
      <ng-container i18n="@@SESSION_ANALYSE_SAVE"> Abbrechen </ng-container>
    </sbb-secondary-button>
  </sbb-dialog-actions>
</form>
